(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-carousel-type-1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const playButtons = document.querySelectorAll('.play-button')

    playButtons.forEach(button => {
      button.addEventListener('click', function () {
        const videoContainer = this.closest('.video-container')
        const video = videoContainer.querySelector('video')
        video.controls = true
        video.play()
        this.style.display = 'none'
      })
    })
  })

  } catch(e) { console.error(e); }
})();
})();
